import { Info } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';

/**
 * Titolo di pagina del backoffice: titolo + icona "i" che apre un popover con le informazioni
 * (sostituisce il sottotitolo descrittivo). `extra` = elementi opzionali accanto al titolo (badge, contatori).
 */
export const PageTitle = ({ title, info, extra = null, className = '', testId = 'page-title' }) => {
  return (
    <div className={`flex items-center gap-2 min-w-0 ${className}`}>
      <h2 className="text-2xl font-bold text-[#1F2A37] truncate" style={{fontFamily:'Space Grotesk'}} data-testid={testId}>{title}</h2>
      {info && (
        <Popover>
          <PopoverTrigger asChild>
            <button
              type="button"
              className="w-6 h-6 rounded-full inline-flex items-center justify-center text-muted-foreground hover:text-[#238A92] hover:bg-[#238A92]/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#238A92]/40 transition-colors flex-shrink-0"
              aria-label={`Informazioni su ${title}`}
              data-testid={`${testId}-info`}
            >
              <Info size={16} />
            </button>
          </PopoverTrigger>
          <PopoverContent align="start" className="w-80 text-sm text-[#1F2A37] leading-relaxed bg-white/95 backdrop-blur-md" data-testid={`${testId}-info-content`}>
            {info}
          </PopoverContent>
        </Popover>
      )}
      {extra}
    </div>
  );
};
